/** Meeting status sections shown in admin accordion + API filters */
export const STATUS_TYPES = [
  "Scheduled",
  "Created",
  "DatesOffered",
  "AdminCare",
  "Done",
  "NoShow",
  "Canceled",
];

/** Accordion sections open by default */
export const DEFAULT_OPEN = ["Scheduled", "Created"];

export const PAGE_SIZE = 20;

/** Default server sort for View Meeting lists (matches previous grid default). */
export const MEETING_LIST_DEFAULT_SORT = {
  sortField: "createdAt",
  sortDir: -1,
};

/** AG Grid column `field` / `colId` → API `sortField` (Mongo Meeting document keys). */
export const MEETING_GRID_FIELD_TO_SORT = {
  "Created Date": "createdAt",
  "Schedule Date": "scheduledDate",
  MeetingStatus: "statuses",
};

/** API `sortField` → AG Grid column id (inverse of above). */
export const MEETING_SORT_FIELD_TO_GRID_COL = {
  createdAt: "Created Date",
  scheduledDate: "Schedule Date",
  statuses: "MeetingStatus",
};

export const BULK_ACTION_MENU = [
  { type: "Change status to", id: "moveto" },
  { type: "Update Doctor", id: "updateDoc" },
];

/** CSV export column order (must match grid field names) */
export const CSV_EXPORT_COLUMN_KEYS = [
  "Meeting Id",
  "Schedule Date",
  "Created Date",
  "Client Name",
  "Physician Name",
  "consultingField",
  "MeetingStatus",
  "Admin comments",
  "Offer Date",
  "Request Description",
  "Age",
  "Email",
  "Client Id",
  "DOB",
  "Gender",
  "Phone",
  "Marital Status",
  "Address",
];
